<template>
  <v-card>
    <div class="header-noti">
      <div><strong>Thông báo {{typePopup === HIGHLIGHT_TYPE.RESERVE ? 'bảo lưu' : 'nghỉ phép'}}</strong></div>
      <div>
        <strong>Lớp học {{product}}:</strong> {{dataShow && dataShow.class ? dataShow.class : '--'}} - {{classname}}
      </div>
    </div>
    <v-card-text>
        <div v-if="loading">
            <span class="skeleton-box" style="width: 80%"></span>
            <span class="skeleton-box" style="width: 80%"></span>
            <span class="skeleton-box" style="width: 80%"></span>
        </div>
        <div v-else>
            <div class="content-noti">
                Học sinh được duyệt đơn {{typePopup === HIGHLIGHT_TYPE.RESERVE ? 'bảo lưu' : 'nghỉ phép'}}
                <span v-if="dataShow.startDate && dataShow.endDate">từ {{dataShow.startDate}} đến {{dataShow.endDate}}</span>
                <span v-else>ngày {{dataShow.startDate ? dataShow.startDate : '--'}}</span>.
            </div>
            <div class="sub-content-noti">Mã đơn: {{dataShow.code ? dataShow.code : '--'}}</div>
            <div class="sub-content-noti">Lý do: {{dataShow.reason ? dataShow.reason : 'chưa xác định'}}.</div>
        </div>
    </v-card-text>
    <v-card-actions class="d-flex justify-center">
      <button class="btn-cancel" @click="$emit('close')">Đóng</button>
    </v-card-actions>
  </v-card>
</template>

<script>
import BlendedCareRepository from '@/services/BlendedCareRepository';
import { HIGHLIGHT_TYPE } from '@/modules/student_detail_bt/const';

export default {
  props: {
    product: {
      type: String,
      default: 'TUTOR',
    },
    soticketid: {
      type: Number,
    },
    typePopup: {
      type: Number,
    },
    classname: {
      type: String,
      default: '--',
    },
  },
  data() {
    return {
      HIGHLIGHT_TYPE,
      loading: false,
      dataShow: null,
    };
  },
  mounted() {
    if (this.soticketid && this.typePopup === HIGHLIGHT_TYPE.RESERVE) this.getStudentHighlightBL();
    if (this.soticketid && this.typePopup === HIGHLIGHT_TYPE.STUDENT_OFF_TICKET) this.getStudentHighlightNP();
  },
  watch: {
    soticketid(val) {
      if (val) {
        if (this.typePopup === HIGHLIGHT_TYPE.RESERVE) this.getStudentHighlightBL();
        if (this.typePopup === HIGHLIGHT_TYPE.STUDENT_OFF_TICKET) this.getStudentHighlightNP();
      }
    },
  },
  methods: {
    async getStudentHighlightBL() {
      this.loading = true;
      const result = await BlendedCareRepository.getStudentHighlightBL(this.soticketid);
      if (result && result.data) {
        this.dataShow = result.data;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng thử lại !!!',
        });
      }
      this.loading = false;
    },
    async getStudentHighlightNP() {
      this.loading = true;
      const result = await BlendedCareRepository.getStudentHighlightNP(this.soticketid);
      if (result && result.data) {
        this.dataShow = result.data;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng thử lại !!!',
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style>
</style>
<style lang="scss" scoped>
.header-noti {
  background: #9887ff;
  color: #fff;
  text-align: center;
  padding: 12px;
}
.btn-cancel {
  border-radius: 10px !important;
  background-color: #f55 !important;
  color: #fff;
  padding: 4px 12px !important;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
}
.content-noti {
    color: #000;
    font-family: Roboto;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; /* 169.231% */
    letter-spacing: 0.5px;
}
.sub-content-noti {
    color: #000;
    font-family: Roboto;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 230.769% */
    letter-spacing: 0.5px;
}
</style>
